import { Box, Button, IconButton, Typography } from '@mui/material';
import { ColumnDef } from '@tanstack/react-table';
import { useDeleteAgencyAgentTemplate, useGetAgencyAgentTemplates } from 'apis/agency/agentTemplate/hook';
import { AgentTemplateResponse } from 'apis/agency/agentTemplate/types';
import DataTable from 'components/Common/DataTable';
import Pagination from 'components/Common/Pagination';
import { useState } from 'react';
import { GoPlus } from 'react-icons/go';
import { MdOutlineEdit } from 'react-icons/md';
import { RiDeleteBin6Line } from 'react-icons/ri';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { titleCase } from 'utils/helperFunctions';

export default function AgentTemplates() {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);

  const { data: agentTemplates, isLoading: isAgentTemplateLoading } = useGetAgencyAgentTemplates(currentPage);

  const { mutate: deleteAgentTemplate } = useDeleteAgencyAgentTemplate();
  return (
    <>
      <Box display='flex' justifyContent='space-between' alignItems='center' mb={2}>
        <Typography variant='h2' fontWeight={500}>
          Agent Templates
        </Typography>
        <Button onClick={() => navigate('add')} variant='contained' color='primary' startIcon={<GoPlus />}>
          Add Template
        </Button>
      </Box>
      <DataTable
        data={agentTemplates?.data}
        columns={columns(deleteAgentTemplate)}
        isHeaderSticky={true}
        isLoading={isAgentTemplateLoading}
      />
      <Pagination totalPages={agentTemplates?.meta?.total_pages} currentPage={currentPage} onChange={setCurrentPage} />
      <Outlet />
    </>
  );
}

type deleteAgentTemplateFn = (id: string) => void;

const columns = (deleteAgentTemplate: deleteAgentTemplateFn): ColumnDef<AgentTemplateResponse>[] => [
  {
    header: 'Name',
    accessorKey: 'name'
  },
  {
    header: 'Languages',
    accessorKey: 'languages',
    cell: (info) => {
      const value = info.getValue() as string[];
      return value?.map((v) => v.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())).join(', ');
    }
  },
  {
    header: 'Agent Name',
    accessorKey: 'agent_name',
    cell: (info) => (info.getValue() as string)?.replace(/_/g, ' ')
  },
  {
    header: 'Tone',
    accessorKey: 'tone'
  },
  {
    header: 'Industry',
    accessorKey: 'industry',
    cell: (info) => titleCase((info.getValue() as string) || '')
  },
  {
    header: 'Agent Interaction',
    accessorKey: 'agent_interaction'
  },
  {
    header: 'Action',
    cell: (info) => (
      <Box display='flex' gap={1}>
        <Link to={String(info.row.original.id)}>
          <IconButton>
            <MdOutlineEdit />
          </IconButton>
        </Link>
        <IconButton onClick={() => deleteAgentTemplate(String(info.row.original.id))} color='error'>
          <RiDeleteBin6Line style={{ color: 'red' }} />
        </IconButton>
      </Box>
    )
  }
];
